// TOTGA Wishlist Functionality
class Wishlist {
  constructor() {
    this.storageKey = 'totga_wishlist';
    this.items = this.load();
    this.init();
  }

  init() {
    this.updateUI();
    this.attachEventListeners();
    this.updateCounter();
  }

  load() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  save() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
      this.updateCounter();
      this.updateUI();
    } catch (e) {
      console.error('Failed to save wishlist:', e);
    }
  }

  add(productId, productData) {
    if (!this.has(productId)) {
      this.items.push({
        id: productId,
        addedAt: Date.now(),
        ...productData
      });
      this.save();
      this.showNotification('Added to wishlist!', 'success');
      return true;
    }
    return false;
  }

  remove(productId) {
    this.items = this.items.filter(item => item.id !== productId);
    this.save();
    this.showNotification('Removed from wishlist', 'info');
  }

  has(productId) {
    return this.items.some(item => item.id === productId);
  }

  toggle(productId, productData) {
    if (this.has(productId)) {
      this.remove(productId);
      return false;
    } else {
      this.add(productId, productData);
      return true;
    }
  }

  getAll() {
    return this.items;
  }

  clear() {
    this.items = [];
    this.save();
  }

  updateCounter() {
    const counters = document.querySelectorAll('[data-wishlist-count]');
    counters.forEach(counter => {
      counter.textContent = this.items.length;
      counter.style.display = this.items.length > 0 ? 'flex' : 'none';
    });
  }

  updateUI() {
    const buttons = document.querySelectorAll('[data-wishlist-button]');
    buttons.forEach(button => {
      const productId = button.dataset.productId;
      const isInWishlist = this.has(productId);
      
      button.classList.toggle('active', isInWishlist);
      button.setAttribute('aria-pressed', isInWishlist);
      
      const icon = button.querySelector('.wishlist-icon');
      if (icon) {
        icon.innerHTML = isInWishlist ? 
          '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>' :
          '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>';
      }

      const label = button.querySelector('span');
      if (label && button.classList.contains('product-wishlist-toggle')) {
        label.textContent = isInWishlist ? 'Saved to Wishlist' : 'Add to Wishlist';
      }
    });
  }

  attachEventListeners() {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-wishlist-button]');
      if (button) {
        e.preventDefault();
        const productId = button.dataset.productId;
        const productData = {
          title: button.dataset.productTitle,
          price: button.dataset.productPrice,
          image: button.dataset.productImage,
          url: button.dataset.productUrl
        };
        
        this.toggle(productId, productData);
        
        // Animate button
        button.style.transform = 'scale(0.8)';
        setTimeout(() => {
          button.style.transform = 'scale(1)';
        }, 200);
      }
    });
  }

  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `wishlist-notification ${type}`;
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => notification.classList.add('show'), 100);
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, 2000);
  }
}

// Initialize wishlist
const wishlist = new Wishlist();
window.wishlist = wishlist;
